import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.handleKeydown = this.handleKeydown.bind(this);
    this.element.addEventListener("keydown", this.handleKeydown);
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.handleKeydown);
  }

  handleKeydown(event) {
    if (event.key === "Enter" && event.target.tagName === "INPUT") {
      event.preventDefault();
      this.focusNextField(event.target);
    }
  }

  focusNextField(currentElement) {
    const focusableSelector =
      "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])";
    const focusableElements = Array.from(
      this.element.querySelectorAll(focusableSelector)
    );
    const currentIndex = focusableElements.indexOf(currentElement);

    if (currentIndex > -1 && currentIndex < focusableElements.length - 1) {
      focusableElements[currentIndex + 1].focus();
    }
  }
}
